import { DollarAmountField, formatDollarValue } from '@hb/shared'
import * as React from 'react'
import { FocusEvent, forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react'
import { InputElement, InputProps } from '../../../../../types/fields'
import { useInputPlaceholder } from '../../hooks'
import InputContainer from '../../Shared/InputContainer'
import { TextInputElement } from '../styles'

const DollarAmountInput: InputElement<DollarAmountField> = forwardRef<
  { focus: () => void },
  InputProps<DollarAmountField>
>((props, ref) => {
  const { input, field, disabled, readOnly, size } = props
  const { onBlur, onChange, value, ...inputProps } = input ?? {}
  const text = useRef(formatDollarValue(input.value) || '$')
  const handleChange = useCallback(
    ({ target: { value: newVal } }: React.ChangeEvent<HTMLInputElement>) => {
      text.current = newVal
      if (inputRef.current) inputRef.current.value = text.current
    },
    [],
  )
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    text.current = value
    if (inputRef.current) inputRef.current.value = text.current
  }, [value])

  const handleBlur = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      e.target.value = text.current
      onChange(e)
      onBlur(e)
    },
    [onBlur, onChange],
  )
  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current?.focus(),
  }))
  const inputPlaceholder = useInputPlaceholder(field)
  return (
    <InputContainer {...props}>
      <TextInputElement
        ref={inputRef}
        disabled={disabled}
        size={size ?? field?.size}
        placeholder={inputPlaceholder}
        onChange={handleChange}
        onBlur={handleBlur}
        readOnly={readOnly}
        {...inputProps}
      />
    </InputContainer>
  )
})

export default DollarAmountInput
